import React from 'react'
import { ReserveStatus } from './ReserveStatus'
import { Col, Row } from 'antd'

export const ReserveInfoComponent = ({ setLoading,showMessage,reserve, showTitle = true,adminMode }) => {
    return (
        <>
            {showTitle ? <Row className='sectionTitle'>
                <Col span={24}>
                    <h2 >
                        اطلاعات رزرو
                    </h2>
                </Col>
            </Row> : <></>
            }
            <div className='container'>
                <Row wrap='wrap'>
                    <Col xs={24} sm={3} md={3} lg={3} xl={3} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            شماره پیگیری
                        </div>

                        <div style={{ padding: '10px' }}>
                            {reserve.trackingCode}
                        </div>
                    </Col>
                    
                    <Col xs={24} sm={4} md={4} lg={4} xl={4} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            نفر اصلی
                        </div>

                        <div style={{ padding: '10px' }}>
                            {reserve.fullName} ({reserve.reserve_Users.filter(x => x.isPrimary)[0]?.nationalCode})
                        </div>
                    </Col>

                    <Col xs={24} sm={3} md={3} lg={3} xl={3} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            تاریخ درخواست
                        </div>

                        <div style={{ padding: '10px' }}>
                            {reserve.createDateShamsi}
                        </div>
                    </Col>
                    <Col xs={24} sm={3} md={3} lg={3} xl={3} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            رزرو شده
                        </div>

                        <div style={{ padding: '10px' }}>
                            {reserve.objectInstance.title}
                        </div>
                    </Col>
                    <Col xs={24} sm={3} md={3} lg={3} xl={3} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            تعداد نفرات
                        </div>

                        <div style={{ padding: '10px' }}>
                            {reserve.reserve_Users.length} نفر
                        </div>
                    </Col>
                    <Col xs={24} sm={8} md={8} lg={8} xl={8} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            وضعیت درخواست
                        </div>

                        <div style={{ padding: '10px' }}>
                            <ReserveStatus
                                reserveStatus={reserve.reserveStatus}
                                reserveId={reserve.id}
                                adminMode={adminMode}
                                showMessage={showMessage}
                                setLoading={setLoading}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}


